import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { ComplianceTermsDataProps } from './props';
import { useEffect, useState } from 'react';
import { ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetLastCodeParam } from '../../../../../../services/param.service';
import { Param } from '../../../../../../shared/types/param';

export const useComplianceTermsData = ({
    data,
    onChangeData,
    onChangeFormik,
}: ComplianceTermsDataProps) => {
    const [newCode, setNewCode] = useState<string>('');

    const onSubmit = (data: Param) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'class',
            data?.class || ParamEnum.PQR_COMPLIANCE_TERMS
        );
        formik?.setFieldValue('code', data?.code || newCode);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('extra', data?.extra || '');
        formik?.setFieldValue('active', data?.active || true);
    }, [data, newCode]);

    useEffect(() => {
        asyncGetLastCodeParam(ParamEnum.PQR_COMPLIANCE_TERMS).then(
            (res: any) => {
                setNewCode(res?.items);
            }
        );
    }, [newCode]);

    return {
        formik,
    };
};
